export { SearchFooterContainer } from './SearchFooterContainer';
